export default "__VITE_ASSET__Bpr48pQ6__"